module.exports = __webpack_public_path__ + "static/media/ksl-logo-animiert.a07496ae.svg";